import React from 'react';
import InfoHero from './InfoHero';
const NewHouses = () => {
  return (
    <>
      <InfoHero />
    </>
  );
};

export default NewHouses;
